<script setup lang="ts">
import { FEEDBACK_COPY } from "@/copy/feedback";

defineProps({ invite: { type: String, required: true } });
</script>

<template>
  <p class="flex items-start gap-2.5 px-4 pt-4 pb-3 text-sm text-gray-900">
    <!-- Fixed width: emoji glyphs differ per OS, and the buttons below align to the text column. -->
    <span
      aria-hidden="true"
      class="animate-wave size-5 shrink-0 text-center text-base leading-5"
    >
      👋
    </span>
    <span class="min-w-0">
      <span class="font-semibold">{{ FEEDBACK_COPY.greeting }}</span>
      {{ invite }}
    </span>
  </p>
</template>
